"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Recurrence_1 = require("./Recurrence");
var TimeHhMm_1 = require("./TimeHhMm");
var Localize_1 = require("../../gen-src/Localize");
var StaticInitializers;
(function (StaticInitializers) {
    StaticInitializers.DEFAULT_DAY_OF_MONTH_ARR = [new Date().getDate()];
    StaticInitializers.DEFAULT_DAY_OF_MONTH_STR = Recurrence_1.RecurrenceConverters.toDaysOfMonthMask(StaticInitializers.DEFAULT_DAY_OF_MONTH_ARR) + '';
    StaticInitializers.DEFAULT_ALL_DAYS_A_WEEK = [Recurrence_1.RecurrenceDaysOfTheWeek.Sun, Recurrence_1.RecurrenceDaysOfTheWeek.Mon,
        Recurrence_1.RecurrenceDaysOfTheWeek.Tue, Recurrence_1.RecurrenceDaysOfTheWeek.Wed, Recurrence_1.RecurrenceDaysOfTheWeek.Thu, Recurrence_1.RecurrenceDaysOfTheWeek.Fri,
        Recurrence_1.RecurrenceDaysOfTheWeek.Sat];
    StaticInitializers.DEFAULT_WEEKDAYS = Recurrence_1.RecurrenceConverters.getDayOfWeek(new Date());
    StaticInitializers.MINUTES_IN_HOUR = 60;
    StaticInitializers.HOURS_IN_DAY = 24;
    StaticInitializers.MINUTES_IN_DAY = StaticInitializers.MINUTES_IN_HOUR * StaticInitializers.HOURS_IN_DAY;
    StaticInitializers.MAX_DAYS_IN_A_MONTH = 31;
    StaticInitializers.NumberOfRecurrenceDaysOfTheWeek = 7;
    var NearestFiveMinutes = Math.round(new Date().getMinutes() / 5) * 5;
    StaticInitializers.DEFAULT_START_TIME = new Date().getHours() * StaticInitializers.MINUTES_IN_HOUR + NearestFiveMinutes;
    StaticInitializers.DEFAULT_END_TIME = StaticInitializers.DEFAULT_START_TIME;
    function defaultRecurrence() {
        return {
            // recurrenceMode: RecurrenceModes.DataRefresh,
            recurrenceMode: Recurrence_1.RecurrenceMode.TimeRecurrence,
            recurrenceType: Recurrence_1.RecurrenceType.Daily,
            recurrenceDetails: defaultDaily()
        };
    }
    StaticInitializers.defaultRecurrence = defaultRecurrence;
    function defaultHourly() {
        return {
            startTime: StaticInitializers.DEFAULT_START_TIME,
            endTime: StaticInitializers.DEFAULT_END_TIME,
            recurrenceMinutes: StaticInitializers.MINUTES_IN_HOUR,
            recurrenceDaysOfWeek: StaticInitializers.DEFAULT_WEEKDAYS
        };
    }
    StaticInitializers.defaultHourly = defaultHourly;
    function defaultDaily() {
        return {
            startTime: StaticInitializers.DEFAULT_START_TIME,
            endTime: StaticInitializers.DEFAULT_END_TIME,
            recurrenceMinutes: StaticInitializers.MINUTES_IN_DAY,
            recurrenceDaysOfWeek: StaticInitializers.DEFAULT_WEEKDAYS
        };
    }
    StaticInitializers.defaultDaily = defaultDaily;
    function defaultWeekly() {
        return {
            startTime: StaticInitializers.DEFAULT_START_TIME,
            recurrenceDaysOfWeek: StaticInitializers.DEFAULT_WEEKDAYS
        };
    }
    StaticInitializers.defaultWeekly = defaultWeekly;
    function defaultMonthly() {
        return {
            startTime: StaticInitializers.DEFAULT_START_TIME,
            recurrenceDayOfMonth: StaticInitializers.DEFAULT_DAY_OF_MONTH_STR,
            recurrenceDaysOfWeek: null
        };
    }
    StaticInitializers.defaultMonthly = defaultMonthly;
})(StaticInitializers = exports.StaticInitializers || (exports.StaticInitializers = {}));
var LocalizationHelpers;
(function (LocalizationHelpers) {
    function getRecurrenceStringLocalized(recurrence) {
        switch (recurrence.recurrenceMode) {
            case Recurrence_1.RecurrenceMode.DataRefresh:
                return Localize_1.Messages.RecurrenceOnDataRefresh();
            case Recurrence_1.RecurrenceMode.TimeRecurrence:
                return getTimelyRecurrenceString(recurrence);
            default:
                throw new Error("Encountered unexpected recurrence mode in recurrence: " + JSON.stringify(recurrence));
        }
    }
    LocalizationHelpers.getRecurrenceStringLocalized = getRecurrenceStringLocalized;
    function getTimelyRecurrenceString(recurrence) {
        // Exhaustive switch means we can't hit default (if the recurrenceType is one that we declared to typescript)
        switch (recurrence.recurrenceType) {
            case Recurrence_1.RecurrenceType.Hourly:
                return getHourlyRecurrenceString(recurrence.recurrenceDetails);
            case Recurrence_1.RecurrenceType.Daily:
                return getDailyRecurrenceString(recurrence.recurrenceDetails);
            case Recurrence_1.RecurrenceType.Weekly:
                return getWeeklyRecurrenceString(recurrence.recurrenceDetails);
            case Recurrence_1.RecurrenceType.Monthly:
                return getMonthlyRecurrenceString(recurrence.recurrenceDetails);
            default:
                throw new Error("Encountered unexpected recurrence type in recurrence: " + JSON.stringify(recurrence));
        }
    }
    LocalizationHelpers.getTimelyRecurrenceString = getTimelyRecurrenceString;
    function getHourlyRecurrenceString(recurrenceDetails) {
        var startTime = TimeHhMm_1.TimeHhMm.fromNumber(recurrenceDetails.startTime);
        var endTime = TimeHhMm_1.TimeHhMm.fromNumber(recurrenceDetails.endTime);
        var localizedRecurrenceMinutes = localizeMinutesNumber(recurrenceDetails.recurrenceMinutes)
            .toLocaleLowerCase();
        var numDays = recurrenceDetails.recurrenceDaysOfWeek.length.toLocaleString();
        var dayOfWeekNum = recurrenceDetails.recurrenceDaysOfWeek.length > 1
            ? Localize_1.Messages.RecurrenceStrDaysAWeek()
            : Localize_1.Messages.RecurrenceStrDayAWeek();
        if (recurrenceDetails.startTime === recurrenceDetails.endTime) {
            return Localize_1.Messages.RecurrenceStrMultipleTimesAnHourStartingAt({
                NUM_DAYS: numDays,
                DAYS: dayOfWeekNum,
                LOC_MIN_NUM: localizedRecurrenceMinutes,
                START_TIME: startTime.toHHMMString(),
            });
        }
        else {
            return Localize_1.Messages.RecurrenceStrMultipleTimesAnHourAt({
                NUM_DAYS: numDays,
                DAYS: dayOfWeekNum,
                LOC_MIN_NUM: localizedRecurrenceMinutes,
                START_TIME: startTime.toHHMMString(),
                END_TIME: endTime.toHHMMString(),
            });
        }
    }
    LocalizationHelpers.getHourlyRecurrenceString = getHourlyRecurrenceString;
    function getDailyRecurrenceString(recurrenceDetails) {
        var startTime = TimeHhMm_1.TimeHhMm.fromNumber(recurrenceDetails.startTime);
        var endTime = TimeHhMm_1.TimeHhMm.fromNumber(recurrenceDetails.endTime);
        var recurrenceMinutes = recurrenceDetails.recurrenceMinutes;
        var numDays = recurrenceDetails.recurrenceDaysOfWeek.length.toLocaleString();
        var dayOfWeekStr = recurrenceDetails.recurrenceDaysOfWeek.length > 1
            ? Localize_1.Messages.RecurrenceStrDaysAWeek()
            : Localize_1.Messages.RecurrenceStrDayAWeek();
        var atOrFromToStr = recurrenceDetails.startTime === recurrenceDetails.endTime
            ? Localize_1.Messages.RecurrenceStrGeneralAt({ START_TIME: startTime.toHHMMString() })
            : Localize_1.Messages.RecurrenceStrGeneralFromTo({ START_TIME: startTime.toHHMMString(), END_TIME: endTime.toHHMMString() });
        var args = {
            NUM_DAYS: numDays,
            DAYS: dayOfWeekStr,
            LOC_MIN_NUM: localizeMinutesNumber(recurrenceMinutes).toLocaleLowerCase(),
            AT_OR_FROM_TO: atOrFromToStr,
        };
        return recurrenceDetails.recurrenceMinutes === Recurrence_1.ONE_DAY
            ? Localize_1.Messages.RecurrenceStrDaily(args)
            : Localize_1.Messages.RecurrenceStrDailyEveryX(args);
    }
    LocalizationHelpers.getDailyRecurrenceString = getDailyRecurrenceString;
    function getWeeklyRecurrenceString(recurrenceDetails) {
        var startTime = TimeHhMm_1.TimeHhMm.fromNumber(recurrenceDetails.startTime);
        var dayOfWeekNum = recurrenceDetails.recurrenceDaysOfWeek.length > 1
            ? Localize_1.Messages.RecurrenceStrDaysAWeek()
            : Localize_1.Messages.RecurrenceStrDayAWeek();
        return Localize_1.Messages.RecurrenceWeeklyVerboseString({
            NUM_DAYS_LOC: recurrenceDetails.recurrenceDaysOfWeek.length.toLocaleString(),
            DAYS: dayOfWeekNum,
            START_TIME: startTime.toHHMMString(),
        });
    }
    LocalizationHelpers.getWeeklyRecurrenceString = getWeeklyRecurrenceString;
    function getMonthlyRecurrenceString(recurrenceDetails) {
        var daysOfMonth = Recurrence_1.RecurrenceConverters.toDaysOfMonthArr(recurrenceDetails.recurrenceDayOfMonth);
        var dayOfMonthCount = daysOfMonth.length > 1
            ? Localize_1.Messages.RecurrenceMonthlyTimesAMonth()
            : Localize_1.Messages.RecurrenceMonthlyTimeAMonth();
        var time = TimeHhMm_1.TimeHhMm.fromNumber(recurrenceDetails.startTime);
        var which = '';
        var what;
        var ofTheMonth;
        var when = time.toHHMMString();
        if (recurrenceDetails.recurrenceDaysOfWeek && recurrenceDetails.recurrenceDaysOfWeek.length > 0) {
            // e.g. second
            which = localizeOnNth(daysOfMonth[0]);
            // e.g. Monday
            what = ' ' + localizeDayOfWeek(recurrenceDetails.recurrenceDaysOfWeek[0]);
            ofTheMonth = Localize_1.Messages.RecurrenceMonthlyOfTheMonth();
        }
        else {
            which = daysOfMonth.length.toLocaleString();
            // e.g.
            what = '';
            ofTheMonth = dayOfMonthCount;
        }
        return Localize_1.Messages.RecurrenceMonthlyVerboseString({
            WHICH: which,
            WHAT: what,
            OF_THE_MONTH: ofTheMonth,
            WHEN: when,
        });
    }
    LocalizationHelpers.getMonthlyRecurrenceString = getMonthlyRecurrenceString;
    function localizeMinutesNumber(recurrenceMinutes) {
        switch (recurrenceMinutes) {
            case Recurrence_1.RecurrenceMinutesNumber.FifteenMinutes:
                return Localize_1.Messages.RecurrenceMinutesFifteenMinutes();
            case Recurrence_1.RecurrenceMinutesNumber.HalfHour:
                return Localize_1.Messages.RecurrenceMinutesHalfHour();
            case Recurrence_1.RecurrenceMinutesNumber.OneHour:
                return Localize_1.Messages.RecurrenceMinutesHour();
            case Recurrence_1.RecurrenceMinutesNumber.TwoHour:
                return Localize_1.Messages.RecurrenceMinutesTwoHour();
            case Recurrence_1.RecurrenceMinutesNumber.FourHour:
                return Localize_1.Messages.RecurrenceMinutesFourHour();
            case Recurrence_1.RecurrenceMinutesNumber.SixHour:
                return Localize_1.Messages.RecurrenceMinutesSixHour();
            case Recurrence_1.RecurrenceMinutesNumber.EightHour:
                return Localize_1.Messages.RecurrenceMinutesEightHour();
            case Recurrence_1.RecurrenceMinutesNumber.TwelveHour:
                return Localize_1.Messages.RecurrenceMinutesTwelveHour();
            case Recurrence_1.RecurrenceMinutesNumber.OneDay:
                return Localize_1.Messages.RecurrenceOnDay();
            default:
                return Localize_1.Messages.RecurrenceMinutesTwoHour();
        }
    }
    LocalizationHelpers.localizeMinutesNumber = localizeMinutesNumber;
    function localizeOnNth(n) {
        switch (n) {
            case 0:
                return Localize_1.Messages.RecurrenceMonthlyOnLast();
            case 1:
                return Localize_1.Messages.RecurrenceMonthlyOnFirst();
            case 2:
                return Localize_1.Messages.RecurrenceMonthlyOnSecond();
            case 3:
                return Localize_1.Messages.RecurrenceMonthlyOnThird();
            case 4:
                return Localize_1.Messages.RecurrenceMonthlyOnFourth();
            case 5:
                return Localize_1.Messages.RecurrenceMonthlyOnFifth();
            default:
                return n + '';
        }
    }
    LocalizationHelpers.localizeOnNth = localizeOnNth;
    function localizeDayOfWeek(dayOfWeek) {
        switch (dayOfWeek) {
            case Recurrence_1.RecurrenceDaysOfTheWeek.Sun:
                return Localize_1.Messages.RecurrenceDayOfWeekSunday();
            case Recurrence_1.RecurrenceDaysOfTheWeek.Mon:
                return Localize_1.Messages.RecurrenceDayOfWeekMonday();
            case Recurrence_1.RecurrenceDaysOfTheWeek.Tue:
                return Localize_1.Messages.RecurrenceDayOfWeekTuesday();
            case Recurrence_1.RecurrenceDaysOfTheWeek.Wed:
                return Localize_1.Messages.RecurrenceDayOfWeekWednesday();
            case Recurrence_1.RecurrenceDaysOfTheWeek.Thu:
                return Localize_1.Messages.RecurrenceDayOfWeekThursday();
            case Recurrence_1.RecurrenceDaysOfTheWeek.Fri:
                return Localize_1.Messages.RecurrenceDayOfWeekFriday();
            case Recurrence_1.RecurrenceDaysOfTheWeek.Sat:
                return Localize_1.Messages.RecurrenceDayOfWeekSaturday();
            default:
                return dayOfWeek + '';
        }
    }
    LocalizationHelpers.localizeDayOfWeek = localizeDayOfWeek;
})(LocalizationHelpers = exports.LocalizationHelpers || (exports.LocalizationHelpers = {}));
//# sourceMappingURL=CreateOrEditRecurrenceModelMapper.js.map